import changeColorPointByRatio from './change-color-point-by-ratio';

const reduceColorPointByRatio = (params, initialShade) => {
  const fallback = {
    rule: 'reduceColorPointByRatio',
    params,
  };

  const paramsWithFallback = params.fallback ? params : { ...params, fallback };
  return changeColorPointByRatio(paramsWithFallback, initialShade, true);
};

export default reduceColorPointByRatio;
